import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';

const defaultSupabaseUrl = 'https://gpyvxwyryibwcbepokpr.supabase.co';
const defaultSupabaseAnonKey = 'sb_publishable_mFpM9nV2AeX77tMM6grQCg_2hZiAI_W';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.VITE_SUPABASE_URL || defaultSupabaseUrl;
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_PUBLISHABLE_KEY || defaultSupabaseAnonKey;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = createClient(supabaseUrl || 'https://localhost.invalid', supabaseAnonKey || 'missing-anon-key', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !Capacitor.isNativePlatform(),
  },
});
